import * as React from 'react';

import { useUploadModel } from 'src/containers/ProjectModelDialog/hooks/useUploadModelValue';
import {
  validateProjectModelIri,
  validateProjectModelName,
} from 'src/containers/ProjectModelDialog/hooks/validators';
import { databaseSelector } from 'src/selectors/database';
import * as copy from 'src/templates/copy';
import { SPECIAL_NAMED_GRAPH_IRIS } from 'src/templates/queries/iris';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const useAddUploadModel = () => {
  const { databaseId, file, name, namedGraphIri } = useUploadModel();
  const database = useReduxSelector(databaseSelector(databaseId));

  const isAddUploadModelEnabled = React.useMemo(
    () => databaseId && Boolean(file),
    [databaseId, file]
  );

  const nameValidationError = React.useMemo(() => {
    const baseError = validateProjectModelName(name);
    if (!database?.models) {
      return baseError;
    }

    if (database.models.includes(name)) {
      return copy.components.projectModelDialog.validation.modelAlreadyExists;
    }

    return baseError;
  }, [database, name]);

  const namedGraphValidationError = React.useMemo(() => {
    const baseError = validateProjectModelIri(namedGraphIri);
    if (!database?.namedGraphs) {
      return baseError;
    }

    if (SPECIAL_NAMED_GRAPH_IRIS.includes(namedGraphIri)) {
      return copy.components.projectModelDialog.validation
        .specialNamedGraphNotAllowed;
    }

    if (database.namedGraphs[namedGraphIri]) {
      return copy.components.projectModelDialog.validation
        .namedGraphAlreadyExists;
    }

    return baseError;
  }, [database, namedGraphIri]);

  return {
    isAddUploadModelEnabled,
    nameValidationError,
    namedGraphValidationError,
  };
};
